import { OpenfinChannelClient, OpenfinChannelProvider } from '../channel';
export class OpenfinChannelHub {
    constructor() {
        this.channels = new Map();
        this.connectToChannel = async (channelLabel, asProvider = false, wait = false) => {
            if (this.channels.has(channelLabel)) {
                return this.channels.get(channelLabel);
            }
            if (asProvider) {
                this.channels.set(channelLabel, await (new OpenfinChannelProvider()).create(channelLabel));
                return this.channels.get(channelLabel);
            }
            return (new OpenfinChannelClient()).create(channelLabel, wait);
        };
    }
}
